import * as React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import SortIcon from "../../../images/sort.png";
import { HeadCell, Order } from "./types";
import { headerCellStyle } from "./CommonTableStyles";

interface CommonTableHeadProps {
  columns: HeadCell[];
  order: Order;
  orderBy: string;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
}

export default function CommonTableHead({
  columns,
  order,
  orderBy,
  onRequestSort,
}: CommonTableHeadProps) {
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => {
          const isSortable = column.sortable !== false;

          return (
            <TableCell
              key={column.id}
              align={column.headerAlignLeft ? "left" : column.alignRight ? "right" : column.alignCenter ? "center" : "left"}
              style={{
                ...headerCellStyle,
                cursor: isSortable ? "pointer" : "default",
                width: column.width,
              }}
              onClick={isSortable ? createSortHandler(column.id) : undefined}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  alignItems: "center",
                  justifyContent: column.headerAlignLeft ? "flex-start" : column.alignRight ? "flex-end" : column.alignCenter ? "center" : "flex-start",
                }}
              >
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "14px",
                    fontFamily: "DM Sans",
                    color: "#000",
                    whiteSpace: column.preventTextWrap ? "nowrap" : "normal",
                    wordBreak: "break-word",
                    lineHeight: "1.3",
                  }}
                >
                  {column.label}
                </span>
                {isSortable && column.label && (
                  <img
                    src={SortIcon}
                    alt="Sort"
                    style={{
                      width: "12px",
                      height: "12px",
                      display: "inline-block",
                      opacity: 0.5,
                    }}
                  />
                )}
              </div>
              {column.description && (
                <div
                  style={{
                    fontSize: "11px",
                    color: "#666666",
                    fontWeight: 400,
                    fontFamily: "DM Sans, sans-serif",
                    lineHeight: "14px",
                    marginTop: "2px",
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                  dangerouslySetInnerHTML={{ __html: column.description }}
                />
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
